module.exports = __webpack_public_path__ + "img/prolongation-2.779e262.png";